import React, {Children} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Chart from './Chart'
import Bar from './Bar'
import {scaleLinear} from 'd3-scale'
import {stack as d3Stack} from 'd3-shape'
import Tooltip from 'components/Tooltip'

export default class HorizontalStackedBarChart extends React.Component {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    className: PropTypes.string,
    data: PropTypes.object,
    tooltip: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      selected: null
    }
  }

  render() {
    const {height, className} = this.props
    const classNames = classnames(
      'horizontal-stacked-bar-chart',
      className
    )

    return (
      <div className={classNames}>
        <Chart height={height}>
          {this.renderStack()}
        </Chart>
        {this.renderTooltip()}
      </div>
    )
  }

  renderStack() {
    const {data, tooltip, children, width, height} = this.props
    const bars = Children.map(children, stackBar => stackBar.props)
    const colors = bars.map(bar => bar.color)
    const keys = bars.map(bar => bar.dataKey)
    const stack = d3Stack().value((d, key) => d[key] || 0).keys(keys)
    const items = stack([data])
    const max = keys.reduce((sum, key) => sum + (data[key] || 0), 0)
    const xScale = scaleLinear().domain([0, max]).rangeRound([0, width])

    return items.map((item, index) => {
      const [x1, x2] = item[0]
      const key = keys[index]
      const value = data[key] || 0
      const percent = value / max
      const onMouseEnter = () => this.onMouseEnter({
        bar: bars[index],
        x1: xScale(x1),
        x2: xScale(x2),
        key,
        value,
        percent
      })
      const onMouseLeave = () => this.onMouseLeave()

      return (
        <Bar
          x={xScale(x1)}
          y={0}
          width={xScale(x2 - x1)}
          height={height}
          color={colors[index]}
          key={index}
          onMouseEnter={tooltip ? onMouseEnter : null}
          onMouseLeave={tooltip ? onMouseLeave : null}
        />
      )
    })
  }

  renderTooltip() {
    const {tooltip} = this.props
    const {selected} = this.state
    if (!tooltip || selected === null) return null
    const {x1, x2} = selected

    return (
      <Tooltip
        x={x1 + ((x2 - x1) / 2)}
        y={0}
        place='top'
      >
        {tooltip(selected)}
      </Tooltip>
    )
  }

  onMouseEnter = item => {
    this.setState({selected: item})
  }

  onMouseLeave = () => {
    this.setState({selected: null})
  }
}



// WEBPACK FOOTER //
// ./client/components/Chart/HorizontalStackedBarChart.js